import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getCountryNominationJudgementCount: (
  fetchContext: FetchContext,
  nominationId: number,
  countryId: number,
  accessToken?: string,
) => Promise<number> = (fetchContext, nominationId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/admin/nominations/${nominationId}/country/${countryId}/judgement-count`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<number>(fetchContext.errorStore, response, 'get nomination judgement count'));